const commands = /\[\s*(?:가챠|운세|다이스|소환|선물|양도|지급|아이템\s+확인)(?=\s|\/|\])/;

// Only the public feed presentation changes. Notifications, the original
// post, profiles and bot delivery retain their existing contents and cursors.
export function hideBotCommandInFeed(type, status, statuses, accounts) {
  if (!/^(?:public|community)(?::|$)/.test(type)) return false;
  const original = status.get('reblog') ? statuses.get(status.get('reblog')) : status;
  if (!original) return false;
  if (status.get('visibility') !== 'public' || original.get('visibility') !== 'public') return true;
  const isBot = id => {
    const account = accounts?.get(id);
    return account?.get('bot') === true || account?.get('acct')?.toLowerCase() === 'sbox_alice';
  };
  if (isBot(status.get('account')) || isBot(original.get('account'))) return true;
  const botMention = original.get('mentions')?.some(account => account.get('acct')?.toLowerCase() === 'sbox_alice' || isBot(account.get('id')));
  return Boolean(botMention && commands.test(original.get('search_index') || ''));
}
